var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0641 23.5515C25.8216 21.9522 27.6769 18.9628 27.6769 15.539C27.6769 10.4304 23.5464 6.28906 18.4512 6.28906C13.3561 6.28906 9.22559 10.4304 9.22559 15.539C9.22559 18.9628 11.0809 21.9522 13.8384 23.5515M23.0641 23.5515H13.8384M23.0641 23.5515V27.8723M13.8384 23.5515V27.8723M23.0641 27.8723V29.414C23.0641 31.1169 21.6872 32.4973 19.9889 32.4973H16.9136C15.2152 32.4973 13.8384 31.1169 13.8384 29.414V27.8723M23.0641 27.8723H13.8384",
    stroke: "#402BAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61302 15.5394H3.07541M6.91943 7.06022L5.38182 5.51855M6.91943 23.2477L5.38182 24.7893",
    stroke: "#402BAB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5208 15.5394H33.0584M29.2144 7.06022L30.752 5.51855M29.2144 23.2477L30.752 24.7893",
    stroke: "#402BAB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/LightBulb.04c723c7.svg";
export { ForwardRef as ReactComponent };